import tenant from 'app/entities/tenant/tenant.reducer';
import fleet from 'app/entities/fleet/fleet.reducer';
import location from 'app/entities/location/location.reducer';
import session from 'app/entities/session/session.reducer';
import activity from 'app/entities/activity/activity.reducer';
import station from 'app/entities/station/station.reducer';
import device from 'app/entities/device/device.reducer';
import type from 'app/entities/session-type/session-type.reducer';
/* jhipster-needle-add-reducer-import - JHipster will add reducer here */

const entitiesReducers = {
  tenant,
  fleet,
  location,
  session,
  activity,
  station,
  type,
  device,
  /* jhipster-needle-add-reducer-combine - JHipster will add reducer here */
};

export default entitiesReducers;
